// extracted by mini-css-extract-plugin
module.exports = {"logosWrapper":"Header_logosWrapper__1CesY","rightButtons":"Header_rightButtons__lMudJ"};